import React, { useEffect, useState } from "react";
import { BadgeVariant, StatusBadgeCheckbox } from "../common/status-badge/StatusBadgeCheckbox";
import DialogBox, { IDialogBoxProps } from "../common/dialogbox/DialogBox";
import ErrorDialogBox, { IOKDialogBoxProps } from "../common/dialogbox/ErrorDialogBox";
import { BadgeType, IStatusBadgeProps } from "../common/status-badge/BadgeType";
import { DNA } from "@dna/react";
import { DangerToolTip } from "../common/tool-tip/DangerToolTip";
import { IDangerTooltip } from "../common/tool-tip/IDangerToolTip";
import { patientService } from "../../services/medicationmanagement/patientApi/PatientApi";
import { Patient } from "../../services/medicationmanagement/patientApi/models/Patient";
import { ExternalLookupIdentifier } from "@communicare/medications/Shared/SharedModels";
import { PatientAllergyInfo } from "../../services/medicationmanagement/patientApi/models/PatientAllergyInfo";

const badgeprops: IStatusBadgeProps = {
    type: BadgeType.Critical,
    fontColour: DNA.tokens.color.white,
    backgroundColour: "#c53535",
    width: "fit-content",
    name: "Allergy update"
};
const dialogprops: IDialogBoxProps = {
    title: "Confirm allergy changes are actioned",
    content: `Are you sure you want to mark the allergy changes as actioned?`,

};
const actionErrorDialogprops: IOKDialogBoxProps = {
    title: "There was a problem marking this change as actioned",
    content: `We have experienced an issue marking the allergy update as actioned. Please try again.`,

};
const confirmErrorDialogprops: IOKDialogBoxProps = {
    title: "There was a problem confirming changes have been actioned",
    content: `We have experienced an issue confirming the allergy update. Please try again.`,

};
export const ResidentAllergyUpdate = (props: {
    dispatch: React.Dispatch<any>,
    state: boolean,
    disclaimer?: string,
    newdisclaimer?: string,
    handleonAllergyActionConfirmed: (val: boolean) => void,
    patient: ExternalLookupIdentifier & PatientAllergyInfo
}) => {

    const [actionError, setActionError] = useState(false);
    const [actionConfirmed, setActionConfirmed] = useState(false);
    const [actionConfirmationError, setActionConfirmationError] = useState(false);

    useEffect(() => {
        if (props.state) {
            const fetchAllergyAction = async () => {
                await patientService.saveAllergyAction(props.patient?.allergyHistory?.id, props.state, props.patient.authoringSystem,
                    props.patient.authoringSystemForeignKey)
                    .then(res =>  setActionError(false))
                    .catch(err => setActionError(true));
            }
            fetchAllergyAction();
        }
    }, [props.state])

    let previouscontent: string | null | undefined = "";
    let currentcontent: string | null | undefined = "";

    props.patient?.allergyHistory?.allergyHistoryDetails?.forEach(function (el: any) {
        previouscontent += el.allergen + `(` + el.reaction + `),`;
    });
    props.patient.allergyHistory?.newAllergyHistoryDetails?.forEach(function (el: any) {
        currentcontent += el.allergen + `(` + el.reaction + `),`;
    });

    let tooltipcontent: IDangerTooltip = {
        previoustitle: "PREVIOUS allergies (and adverse reactions)", //props.patient.allergyHistory?.note,
        previousnote: props.patient.allergyHistory?.note,
        previousdisclaimer: props.disclaimer,
        previouscontent: previouscontent.replace(/,\s*$/, ""),
        currenttitle: "New allergies (and adverse reactions)",
        currentnote: props.patient.allergyHistory?.newNote,
        currentdisclaimer: props.newdisclaimer,
        currentcontent: currentcontent.replace(/,\s*$/, ""),
    }

    const handleonAllergyActionConfirmed = async (value: boolean) => {
        setActionConfirmed(value);
        if (!value) {
            patientService.saveAllergyAction(props.patient.allergyHistory?.id, value, props.patient.authoringSystem,
                props.patient.authoringSystemForeignKey)
                .then(res => setActionConfirmationError(false))
                .catch(err => setActionConfirmationError(true));

        } else {
            await patientService.saveAllergyActionConfirmation(props.patient.allergyHistory?.id, value, props.patient.authoringSystem,
                props.patient.authoringSystemForeignKey)
                .then(res => {
                    setActionConfirmationError(false)
                    props.handleonAllergyActionConfirmed(value);
                })
                .catch(err => setActionConfirmationError(true));
        }
    }

    return (<>
        <DangerToolTip previoustitle={tooltipcontent.previoustitle} previousnote={tooltipcontent.previousnote}
            previousdisclaimer={tooltipcontent.previousdisclaimer} previouscontent={tooltipcontent.previouscontent}
            currenttitle={tooltipcontent.currenttitle} currentnote={tooltipcontent.currentnote}
            currentdisclaimer={tooltipcontent.currentdisclaimer} currentcontent={tooltipcontent.currentcontent} >
            <StatusBadgeCheckbox
                IStatusBadgeProps={badgeprops} dispatch={props.dispatch} state={props.state} kind={BadgeVariant.critical}
            />
        </DangerToolTip>

        {actionError ?
            <ErrorDialogBox dialogBoxProps={actionErrorDialogprops} dispatch={props.dispatch} state={props.state}
                onactionedConfirmed={handleonAllergyActionConfirmed}
            /> :
            <DialogBox dialogBoxProps={dialogprops} dispatch={props.dispatch} state={props.state}
                onactionedConfirmed={handleonAllergyActionConfirmed} />
        }
        {actionConfirmationError ? <ErrorDialogBox dialogBoxProps={confirmErrorDialogprops} dispatch={props.dispatch} state={actionConfirmed}
            onactionedConfirmed={handleonAllergyActionConfirmed} /> : <></>}
    </>
    );
};
